import 'src/global.css';

import { useEffect } from 'react';

import { usePathname } from 'src/routes/hooks';

import { CookieConsent } from 'src/components/cookie-consent';
import { SsoRedirectOverlay } from 'src/components/auth-handoff';

import { themeConfig, ThemeProvider } from './theme';
import { refreshCSRFToken } from './api/utils/csrf-token-manager';
import usePreventNumberInputScroll from './hooks/usePreventNumberInputScroll';

type AppProps = {
  children: React.ReactNode;
};

export default function App({ children }: AppProps) {
  useScrollToTop();
  useInitializeCSRFToken();
  usePreventNumberInputScroll();

  return (
    <ThemeProvider
      noSsr
      defaultMode={themeConfig.defaultMode}
      modeStorageKey={themeConfig.modeStorageKey}
    >
      {children}
      <CookieConsent />
      <SsoRedirectOverlay />
    </ThemeProvider>
  );
}

function useInitializeCSRFToken() {
  useEffect(() => {
    refreshCSRFToken();
  }, []);
}

function useScrollToTop() {
  const pathname = usePathname();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}
